import { apiClient } from './apiClient'

// Tipos para el formulario de contacto
export interface ContactFormData {
  name: string
  email: string
  phone: string
  message: string
  vendorId: number
  locationId: number
  createdBy: string
  type?: string // "getintouch" | "member"
  category?: string // Para GetInTouchWidget (reemplaza "interest")
  email_agent?: string // Opcional, para AgentContact
  embedId?: string // Opcional, ID del embed
  url?: string
  data_property_contact?: {
    propertyId: string
    propertyName: string
    address: string
  }
}

export interface ContactFormResponse {
  success: boolean
  message?: string
  data?: any
}

/**
 * Envía el formulario de contacto
 * Usa el apiClient configurado que ya maneja el token Bearer automáticamente
 * @param data - Datos del formulario de contacto
 */
export const submitContactForm = async (
  data: ContactFormData
): Promise<ContactFormResponse> => {
  try {
    const response = await apiClient.post(
      '/api/hq-nd/Member/submitContactForm',
      data
    )
    return response.data
  } catch (error: any) {
    console.error('Error submitting contact form:', error)
    throw new Error(
      error.response?.data?.message || 
      error.message || 
      'Error al enviar el formulario de contacto'
    )
  }
}

export default submitContactForm

